import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { shouldForwardProp } from '../../utils';
var ProgressBarTrack = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "ProgressBar__ProgressBarTrack",
  componentId: "sc-1d2d29c-0"
})(["position:relative;height:10px;margin:0.5em 0;border-radius:10px;background:", ";overflow:hidden;"], function (_ref) {
  var theme = _ref.theme,
      trackColor = _ref.trackColor;
  return theme.colors[trackColor];
});
var ProgressBarInner = styled.div.withConfig({
  displayName: "ProgressBar__ProgressBarInner",
  componentId: "sc-1d2d29c-1"
})(["position:absolute;top:0;left:0;bottom:0;border-radius:10px;width:", ";background:", ";"], function (_ref2) {
  var progress = _ref2.progress;
  return !isNaN(progress) ? "".concat(progress, "%") : 0;
}, function (_ref3) {
  var theme = _ref3.theme,
      progressColor = _ref3.progressColor;
  return theme.colors[progressColor];
});
/**
 * @component
 * Renders an progress bar with progress from 0 - 100.
 */

var ProgressBar = function ProgressBar(props) {
  return /*#__PURE__*/React.createElement(ProgressBarTrack, props, /*#__PURE__*/React.createElement(ProgressBarInner, {
    progress: props.progress,
    progressColor: props.progressColor
  }));
};

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  trackColor: PropTypes.string,
  progressColor: PropTypes.string
};
ProgressBar.defaultProps = {
  trackColor: 'data7',
  progressColor: 'bgAlternate'
};
export default ProgressBar;